import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from 'react-bootstrap-table2-paginator';
import Loader from "../../../components/Common/Loader";
import useItemHistoryOfMovements from "../Hooks/useItemHistoryOfMovements";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { useHistory } from "react-router-dom"
import { Tooltip } from "../../../components/Utils/Tooltips";
import { More } from "../../../components/Icons/Icons";

export default function InventoryItemMovementHistoryList({ initValue: { itemId } }) {
    const { t } = useTranslation();
    const [historyLog, isLoading, navigation] = useItemHistoryOfMovements({ itemId: itemId, pageNumber: 1, pageSize: 5 });
    const historyRouter = useHistory();

    function handleTableChange(type, { page, sizePerPage, sortField, sortOrder }) {
        navigation.ToPage({
            page
        })
    }

    const handleShowMoveDetail = (dispenseId) => {
        historyRouter.push(`/admin/inventory/pharmacy/${dispenseId}/detail`)
    }

    const columns = [
        {
            dataField: 'moveType', text: t('commons.type'), headerStyle: { width: '7rem' }
            , formatter: (cell, row) => t(`inventory.movements.moveType.${cell}`)
        },
        {
            text: t('commons.date'), headerStyle: { width: '6rem' }
            , formatter: function (_cell, move, rowIndex) {
                return moment(move.createAt).format("DD/MM/YYYY HH:mm");
            }
        },
        {
            dataField: 'status', text: t('commons.state'), headerStyle: { width: '7rem' }
            , formatter: (cell, row) => t(`inventory.movements.moveState.${cell}`)
        },
        {
            dataField: 'assignmentType', text: t('inventory.movements.commons.destination'), headerStyle: { width: '7rem' }
            , formatter: (cell, row) => `${t('inventory.movements.assignmentType.' + cell)}`
        },
        {
            text: t('inventory.movements.commons.assignment'), headerStyle: { width: '7rem' }
            , formatter: (cell, row) => row.assignName
        },
        {
            test: '', headerStyle: { width: '2rem' }, isDummyField: true, headerClasses: 'header-actions', classes: 'row-actions',
            formatter: (cell, row) => (<>
                <button className="btn-table-actions" onClick={() => { handleShowMoveDetail(row.id) }}>
                    <Tooltip tooltip={t('commons.viewDetails')} id={"tooltipedit-" + row.Id}>
                        <span aria-hidden="true"><More /></span>
                    </Tooltip>
                </button>
            </>)
        }
    ]

    return (<Loader isLoading={isLoading}>
        <BootstrapTable
            bordered={false}
            hover
            remote
            condensed
            keyField='id'
            classes="table-spaced table-spaced-small"
            wrapperClasses="table-responsive"

            pagination={paginationFactory({
                page: historyLog.PageNumber,
                sizePerPage: historyLog.PageSize,
                totalSize: historyLog.TotalCount,
                hideSizePerPage: true
            })}

            onTableChange={handleTableChange}

            data={historyLog.Values}
            columns={columns}
            loading={isLoading}
            noDataIndication={() => <>{t("commons.noData")}</>}
        />
    </Loader>)
}